import { render, staticRenderFns } from "./DisclaimerPhotoGER.vue?vue&type=template&id=594f6299&"
import script from "./DisclaimerPhotoGER.vue?vue&type=script&lang=js&"
export * from "./DisclaimerPhotoGER.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports